import { connect } from 'react-redux';
import { setError } from '@/actions';
import { newPurchase } from '@/actions/purchase';

import ExchangeTripList from './ExchangeTripList';

const mapStateToProps = ({ config, exchange, tripFilters, seatsBus }) => {
  const {
    ticket: { nit, openTicket, document, email },
    trip: originalTrip,
    passengers,
    walletOriginalType,
    parentHasFlatfare,
    selectedPassengerToAlter,
    allPassengers,
  } = exchange;
  const operationNumbers = passengers?.map((passenger) => passenger.transporterKey);

  // Get the selected passenger info for display
  const selectedPassenger = selectedPassengerToAlter?.ticketKey
    ? allPassengers?.[selectedPassengerToAlter.nodeTripName]?.find(
        (p) => p.transporterKey === selectedPassengerToAlter.ticketKey,
      )
    : passengers?.[0];

  return {
    operationNumbers,
    nit,
    document,
    openTicket,
    email,
    paymentPlans: config.paymentPlans || [],
    installmentsMinAmount: config.installmentsMinAmount,
    tripFilters,
    walletOriginalType,
    parentHasFlatfare,
    // Original ticket info for display
    originalTrip,
    selectedPassenger,
    // Exchange passenger data for seat selection limits
    exchangePassengers: passengers,
    // Seats state for getting selected seats from results
    seatsBus,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setError: () => dispatch(setError(1, 'Ocurrio un error al buscar viajes', 'warning', false)),
    newPurchase: (originSlug, seenPrice, exchangeData, preSelectedSeats) => {
      return dispatch(
        newPurchase(
          originSlug,
          null,
          'A1',
          seenPrice,
          false,
          true,
          exchangeData,
          false, // redirect
          '', // redirectedFrom
          null, // tripInfo
          preSelectedSeats, // preSelectedSeats - this will be sent as pre_selected_seats to backend
        ),
      );
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ExchangeTripList);
